import { render, staticRenderFns } from "./Vars_table.vue?vue&type=template&id=47e97a16&scoped=true&"
import script from "./Vars_table.vue?vue&type=script&lang=js&"
export * from "./Vars_table.vue?vue&type=script&lang=js&"
import style0 from "./Vars_table.vue?vue&type=style&index=0&id=47e97a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e97a16",
  null
  
)

export default component.exports